import { useQuery } from "@tanstack/react-query";
import { getResources } from "@/api";
import { Resource } from "@/types";

export const useResources = () => {
  const query = useQuery<Resource[]>({
    queryKey: ["resources"],
    queryFn: getResources,
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};
